// What waits on support in 工单管理, for the menu's count and the list's
// head: read when the console starts and every minute after, and again by
// a ticket page as soon as it has changed a ticket.
import { ref } from 'vue'
import { api, type StaffTicketSummary } from '@/api/client'

export const ticketSummary = ref<StaffTicketSummary | null>(null)

let timer: ReturnType<typeof setInterval> | undefined

export async function refreshTickets() {
  try {
    ticketSummary.value = await api.ticketSummary()
  } catch {
    // The counts stay as they were; the pages say what failed.
  }
}

/** Starts the minute's refresh, once. */
export function watchTickets() {
  if (timer) return
  void refreshTickets()
  timer = setInterval(() => void refreshTickets(), 60_000)
}
